import React from "react";
import {
  PanelDialog,
  PanelHeading,
  PanelActions,
  PanelRow,
  Button,
  Label,
  TextInput,
} from "@backslashbuild/pp-ui";
import {
  useUploadUnsuccessfulContributions,
  invalidateContributions,
  useGetContributionScheduleExport,
} from "./api";
import { publish } from "../../pubSub";
import { useParams } from "react-router-dom";

export default function UploadUnsuccessfulContributionsDialog() {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [file, setFile] = React.useState(null);

  const { exportId } = useParams();

  const { data, loading, error, queryId } = useGetContributionScheduleExport({
    exportId,
  });

  const disabled = loading || !data || error || data?.value?.unsuccessfulContributionsIdentified;

  const upload = useUploadUnsuccessfulContributions(exportId);

  function handleCancel() {
    setDialogOpen(false);
  }

  async function handleSubmit() {
    publish("notification", "Uploading file...");

    const result = await upload(file);
    publish("notification", "Upload complete");

    invalidateContributions();
    handleCancel();
  }

  if (data?.value?.unsuccessfulContributionsIdentified)
    return (
      <Button disabled style={{ marginRight: 10 }}>
        Unsuccessful Contributions Submitted
      </Button>
    );

  return (
    <>
      <Button onClick={() => setDialogOpen(true)} disabled={disabled} style={{ marginRight: 10 }}>
        Submit Unsuccessful Contribution
      </Button>

      <PanelDialog onClose={handleCancel} open={dialogOpen}>
        <PanelHeading>Upload Unsuccessful Contribution File</PanelHeading>
        <PanelRow>
          <Label label="Choose file">
            <TextInput type="file" onChange={(e) => setFile(e.target.files[0])} />
          </Label>
        </PanelRow>
        <PanelActions>
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="primary" disabled={!file} onClick={handleSubmit}>
            Submit
          </Button>
        </PanelActions>
      </PanelDialog>
    </>
  );
}
